import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-grid-button-renderer',
  templateUrl: './ag-grid-button-renderer.component.html',
  styleUrls: ['./ag-grid-button-renderer.component.css']
})
export class AgGridButtonRendererComponent implements ICellRendererAngularComp, OnDestroy {

  private params: any;

  public get buttonColor(): string {
    return this.params?.buttonColor;
  }
  public get buttonIcon(): string {
    return this.params?.buttonIcon;
  }
  public get buttonText(): string {
    return this.params?.buttonText;
  }

  agInit(params: any): void {
    this.params = params;
  }

  onClick() {
    if (this.params.onClick) {
      this.params.onClick(this.params);
    } else {
      console.error('[AgGridButtonRendererComponent:onClick] no callback provided as cellRendererParams');
    }
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
